import React from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";

const ModalWrapper: React.FC<
  ModalProps & {
    id?: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    title?: React.ReactNode;
    className?: string;
    titleIcon?: React.ReactNode;
    stickyCloseButton?: boolean;
    showHeader?: boolean;
    bgColorSecondary?: boolean;
    fullHeight?: boolean;
    "data-testid"?: string;
  }
> = ({
  id,
  children,
  footer,
  show = true,
  title,
  onHide = () => {},
  className = "",
  size,
  backdrop,
  titleIcon,
  stickyCloseButton,
  showHeader = true,
  bgColorSecondary = false,
  centered = false,
  fullHeight = false,
  "data-testid": dataTestId,
  ...otherProps
}) => {
  const classNames = `${className} ${
    stickyCloseButton ? "modal--sticky-close-btn" : ""
  } ${bgColorSecondary ? "modal--bg-color-secondary" : ""} ${
    fullHeight ? "modal--full-height" : ""
  }`;

  return (
    <Modal
      id={id}
      backdrop={backdrop}
      show={show}
      onHide={onHide}
      className={classNames}
      size={size}
      autoFocus={false}
      centered={centered || fullHeight}
      data-testid={dataTestId}
      {...otherProps}
    >
      {(!showHeader || stickyCloseButton) && (
        <div
          className={`modal__close-btn-container ${
            stickyCloseButton ? "modal__close-btn-container--sticky" : ""
          }`}
        >
          <button className="btn-close" onClick={onHide} />
        </div>
      )}
      {showHeader && (
        <Modal.Header closeButton={!stickyCloseButton}>
          <Modal.Title
            as="h2"
            data-testid={dataTestId ? `${dataTestId}_title` : null}
          >
            {titleIcon && (
              <span className="modal-title__icon-container">{titleIcon}</span>
            )}
            {title}
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body data-testid={dataTestId ? `${dataTestId}_content` : null}>
        {children}
      </Modal.Body>
      {footer && (
        <Modal.Footer data-testid={dataTestId ? `${dataTestId}_footer` : null}>
          {footer}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalWrapper;
